import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const featureFlagCheckKeys = <T extends QueryKey>(keys: T) => {
  const checkKeys = [...keys, 'checks'] as const;
  return createQueryKey({
    all: checkKeys,
    id: <U extends QueryKeyParam>(uuid: U) =>
      createQueryKey({
        all: [...checkKeys, uuid] as const,
        detail: [...checkKeys, uuid, 'detail'] as const,
      }),
  });
};

export { featureFlagCheckKeys };
